import { multiAddEventListener, multiRemoveEventListener } from '../../assets/js/helpers';

export default class HoverGroup {

	static selector = '[data-hover-group]';

	// class variables

	el = {};

	states = {
		itemActive: null
	};

	// constructor

	constructor(container) {
		this.el = {
			container,
			items: container.querySelectorAll('[data-hover-group-item]')
		};

		this.initialize();
	}

	// init

	initialize() {
		this.#addEventListeners();
	}

	// event listeners

	#addEventListeners = () => {
		multiAddEventListener(this.el.items, 'mouseenter', this.#onItemOver);
		multiAddEventListener(this.el.items, 'mouseleave', this.#onItemOut);
	}

	#removeEventListeners = () => {
		multiRemoveEventListener(this.el.items, 'mouseenter', this.#onItemOver);
		multiRemoveEventListener(this.el.items, 'mouseleave', this.#onItemOut);
	}

	// listener methods

	#onItemOver = (e) => {
		if (this.states.itemActive) {
			this.states.itemActive.classList.remove('is-hover-active');
		}

		this.states.itemActive = e.currentTarget;
		this.states.itemActive.classList.add('is-hover-active');

		this.el.container.classList.add('is-hover-active');
	}

	#onItemOut = () => {
		if (this.states.itemActive) {
			this.states.itemActive.classList.remove('is-hover-active');
			this.states.itemActive = null;
		}

		this.el.container.classList.remove('is-hover-active');
	}

	// destroy

	destroy() {
		this.#removeEventListeners();
	}

}
